export default __webpack_public_path__ + "static/media/Belt of the Precursor.7df109e6.jpg";